/**
 * Post-auth navigation for first-time signups vs returning users.
 */
export function getPostAuthPath(
  isNewUser: boolean,
  storageLinked: boolean,
  isAnonymous = false,
  requiresExternalDrive = false,
): string {
  if (isAnonymous) {
    return isNewUser ? '/welcome' : '/dashboard';
  }
  if (storageLinked) {
    return isNewUser ? '/welcome' : '/dashboard';
  }
  if (requiresExternalDrive) {
    return '/auth/storage';
  }
  return '/auth/storage';
}

export function getPostStoragePath(isNewUser: boolean): string {
  return isNewUser ? '/welcome' : '/dashboard';
}
